import React from "react";
import { cn } from "@/lib/utils";

const ROLE_STYLES = {
  "Super Admin": "bg-slate-900 text-white border-slate-900",
  "Tenant Admin": "bg-slate-100 text-slate-900 border-slate-200",
  "HR Admin": "bg-blue-50 text-blue-700 border-blue-200",
  "HR Business Partner": "bg-violet-50 text-violet-700 border-violet-200",
  Manager: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Employee: "bg-slate-50 text-slate-600 border-slate-200",
};

export default function RoleBadge({ role, className }) {
  return (
    <span
      data-testid={`role-badge-${(role || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium border tracking-wide uppercase",
        ROLE_STYLES[role] || ROLE_STYLES.Employee,
        className
      )}
    >
      {role}
    </span>
  );
}
